import { Info, SquarePen } from "lucide-react";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import { pillButtonClassName } from "./assistantClasses";

interface ConversationFullCardProps {
    /** Step-based contract: the conversation is full (gauge at 100 %); v1: 8 exchanges reached. */
    hasConversationMemory: boolean;
    isResetting: boolean;
    onNewConversation: () => void;
}

/** In place of the input bar once the conversation can't go on: the only way on is a new conversation. */
const ConversationFullCard = ({
    hasConversationMemory,
    isResetting,
    onNewConversation,
}: ConversationFullCardProps) => {
    const { t } = useTranslation();
    const titleId = useId();

    return (
        <section
            aria-labelledby={titleId}
            className="flex w-full flex-col gap-3 rounded-2xl border border-assistant-highlight bg-white p-4"
        >
            <div className="flex items-center gap-2.5">
                <Info
                    aria-hidden
                    className="size-4 flex-none text-primary-dark"
                />
                <h2
                    className="text-base font-semibold text-primary-darkest"
                    id={titleId}
                >
                    {t("vistassistant.conversationFullTitle")}
                </h2>
            </div>
            <p className="text-sm leading-relaxed text-assistant-muted">
                {hasConversationMemory
                    ? t("vistassistant.conversationFull")
                    : t("vistassistant.conversationLimitReached")}
            </p>
            <div className="flex flex-wrap gap-2">
                <button
                    className={pillButtonClassName}
                    disabled={isResetting}
                    onClick={onNewConversation}
                    type="button"
                >
                    <SquarePen aria-hidden />
                    {t("vistassistant.newConversation")}
                </button>
            </div>
        </section>
    );
};

export default ConversationFullCard;
